$('input[type="checkbox"], input[type="radio"]').on('change', function() {
    var $this = $(this);

    $this.closest('form').find('label').removeClass('is-active');

    if ($this.is(':checked')) {
        $this.closest('label').addClass('is-active');
    }

    return false;
});